import { useCallback, useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { PageHeader } from "../../components/dash/ui";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import { Pill, CONTRACT_STATUS, Disclaimer } from "./shared";
import { ContractTab } from "./ContractTab";
import { AccountsTab } from "./AccountsTab";
import { CostsTab } from "./CostsTab";
import { SalesTab } from "./SalesTab";
import { ReportTab } from "./ReportTab";

const TABS = [["kontrak", "Skema & Perjanjian"], ["rekening", "Rekening Penerima"], ["biaya", "Biaya Terkait"], ["panen", "Penjualan & Realisasi"], ["laporan", "Laporan & Distribusi"]];

export default function ProfitDetail() {
  const { id } = useParams();
  const tabParam = useSearchParams()[0].get("tab");
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get(`/profit/contracts/${id}`).then((r) => setData(r.data)).catch((e) => toast.error(formatApiError(e))), [id]);
  useEffect(() => { load(); }, [load]);
  if (!data) return <p className="text-sm text-slate-500" data-testid="profit-loading">Memuat...</p>;
  const c = data.contract;
  const props = { data, reload: load };
  return (
    <div data-testid="profit-detail-page">
      <Link to=".." relative="path" className="inline-flex items-center gap-1 text-sm text-emerald-800 font-semibold mb-4 print:hidden" data-testid="back-to-list"><ArrowLeft className="h-4 w-4" />Semua skema</Link>
      <PageHeader title={`Skema & Bagi Hasil Kebun ${c.projectCode || ""}`} subtitle={`${c.projectName || ""} · Kelompok Tani/Koperasi: ${c.farmerGroupName || "-"} · Investor: ${c.investorName || "-"}`}
        action={<span className="w-fit"><Pill map={CONTRACT_STATUS} value={c.status} testid="contract-status" /></span>} />
      <div className="mb-6 print:hidden"><Disclaimer text={data.disclaimer} /></div>
      <Tabs defaultValue={TABS.some(([v]) => v === tabParam) ? tabParam : "kontrak"}>
        <TabsList className="flex flex-wrap h-auto justify-start gap-1 bg-slate-100 p-1 print:hidden" data-testid="profit-tabs">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`tab-${v}`}>{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="kontrak" className="mt-6"><ContractTab {...props} /></TabsContent>
        <TabsContent value="rekening" className="mt-6"><AccountsTab {...props} /></TabsContent>
        <TabsContent value="biaya" className="mt-6"><CostsTab {...props} /></TabsContent>
        <TabsContent value="panen" className="mt-6"><SalesTab {...props} /></TabsContent>
        <TabsContent value="laporan" className="mt-6"><ReportTab {...props} /></TabsContent>
      </Tabs>
    </div>
  );
}
